module.exports = __webpack_public_path__ + "img/critical-thinking.20bad980.gif";